// Get job search tooltip data ******************************
// pathname: /v1/job-search-tooltip
// ******************************************************
import { useSwrApi } from '@hooks/useSwrApi';

interface UseSwrJobSearchTooltipProps {
  locale?: Locale;
  shouldFetch?: boolean;
}

/**
 * @description SWR fetch job search tooltip data (recent/saved searches).
 * - **locale**: string, optional. What locale to use for the request. Default 'ro'.
 * - **shouldFetch**: boolean, optional. Whether to fetch the data or not. Default true.
 */
export const useSwrJobSearchTooltip = (props: UseSwrJobSearchTooltipProps) => {
  const {
    locale = 'ro',
    shouldFetch = true,
  } = props;

  // Get data from API
  // ********************************************
  const {
    data, error, isLoading, isValidating, mutate,
  } = useSwrApi<ApiSchema<'JobSearchToolTip'>>({
    url: '/v1/job-search-tooltip',
    locale,
    shouldFetch,
    apiOptions: {
      // 1 minute
      dedupingInterval: 60 * 1000,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    },
  });


  // Return data
  // ********************************************
  return {
    data,
    error,
    mutate,
    isLoading,
    isValidating,
  };
};
